import {Injectable} from "@angular/core";
import {NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs";
import {IonNav, MenuController, ModalController, NavController} from "@ionic/angular";
import {
  ModalPagesContainerComponent
} from "../components/modal-pages-container/modal-pages-container.component";
import {LoginPage} from "../../users/login/login.page";
import {RegisterFeaturePage} from "../../register-feature/register-feature.page";
import {LoginMailComponent} from "../../users/login/login-mail/login-mail.component";
import {RegisterPage} from "../../users/register/register.page";
import {RegisterSocialPage} from "../../users/register-social/register-social.page";
import {PrivacyContentComponent} from "../components/privacy-content/privacy-content.component";
import {PrivacyModalComponent} from "../../privacy/privacy-modal/privacy-modal.component";
import {serviceSectionType} from "../types/types";
import {CommonService} from "./common.service";

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  private _fromDeeplinkUrl: string;
  private _wasteBack: string;
  private history: string[] = [];
  private currentNav: IonNav;
  private _modalStackLength: number = 0;
  private _navigationAfterLogin: string[];

  constructor(private router: Router,
              private modalCtrl: ModalController,
              private menuController: MenuController,
              private commonService: CommonService,
              private navCtrl: NavController) {
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    //@ts-ignore
    .subscribe((event: NavigationEnd) => {
      this.history.push(event.urlAfterRedirects);
    });
  }

  hasNavigationAfterLogin() {
    return !!this._navigationAfterLogin && this._navigationAfterLogin.length > 0 && !this._navigationAfterLogin.includes('');
  }

  get wasteBack(){
    return this._wasteBack;
  }

  set wasteBack(wasteBack: string){
    this._wasteBack = wasteBack;
  }

  get navigationAfterLogin() {
    console.log("navigationAfterLogin", this._navigationAfterLogin);
    return this._navigationAfterLogin || [''];
  }

  useNavigationAfterLogin() {
    const url = this._navigationAfterLogin || [''];
    this._navigationAfterLogin = [''];
    console.log("navigationAfterLogin-url", url);
    this.goRoot(url);
  }

  set navigationAfterLogin(navigationAfterLogin: string[]) {
    this._navigationAfterLogin = navigationAfterLogin;
  }

  get modalStackLength() {
    return this._modalStackLength;
  }

  get fromDeeplinkUrl() {
    return this._fromDeeplinkUrl;
  }

  set fromDeeplinkUrl(fromDeeplinkUrl: string) {
    this._fromDeeplinkUrl = fromDeeplinkUrl;
  }

  clearFromDeeplinkUrl() {
    this._fromDeeplinkUrl = undefined;
  }

  useFromDeeplinkUrl() {
    this.navCtrl.navigateForward(this._fromDeeplinkUrl);
    this._fromDeeplinkUrl = undefined;
  }

  onOpenSection(id: serviceSectionType, hasUserZone: boolean, link: string) {

    const wasteCallback = () => {
      if (hasUserZone) {
        this.navCtrl.navigateForward(['waste']);
      } else {
        this.wasteBack = 'waste';
        this.navCtrl.navigateForward(['/waste/settings']);
      }
    }

    switch (id) {
      case 'waste':
        wasteCallback();
        break;
      case 'avvisi-pubblici':
        this.commonService.onOpenLinkBrowser('https://www.comune.andria.bt.it/it/news-category/145030?type=3');
        break;
      case 'contact':
        this.commonService.openContactDrawer.next(true);
        this.menuController.close();
        break;
      default:
        this.navCtrl.navigateForward(link)
        break;
    }

  }

  canGoBack(): boolean {
    return this.history.length > 1;
  }

  goRoot(urls: string[]) {
    this.history = [];
    this.navCtrl.navigateRoot(urls);
  }

  async openPagesModal(pageAlias: ModalPageAlias) {

    const modal = await this.modalCtrl.create({
      component: ModalPagesContainerComponent,
      componentProps: {pageAlias}
    });

    this._modalStackLength = 0;
    await modal.present();
  }

  async forwardModal(pageAlias: ModalPageAlias) {

    console.log("forwardModal", pageAlias);
    this.currentNav.push(this._getModalNavigationComponent(pageAlias));
    this._modalStackLength += 1;
  }

  popModal() {
    this.currentNav.pop();
    this._modalStackLength -= 1;
  }

  closeModal(data?) {
    this.currentNav = undefined;
    this.modalCtrl.dismiss();
  }

  async setModalNavigationPages(ionNav: IonNav, alias: ModalPageAlias) {

    if (!this.currentNav) {
      this.currentNav = ionNav;
      console.log("setModalNavigationPages", ionNav);
    }

    ionNav.setRoot(this._getModalNavigationComponent(alias));
  }

  private _getModalNavigationComponent(alias: ModalPageAlias) {

    switch (alias) {
      case 'login':
        return LoginPage;
      case 'register_feature':
        return RegisterFeaturePage;
      case 'login_mail':
        return LoginMailComponent;
      case 'register_mail':
        return RegisterPage;
      case 'register_social':
        return RegisterSocialPage;
      case 'policy':
        return PrivacyModalComponent;
      default:
        console.log("_getModalNavigationComponent_defult: LoginPage");
        return LoginPage;
    }

  }

}


export type ModalPageAlias = 'login' | 'register_feature' | 'login_mail' | 'register_mail' | 'register_social' | 'policy';
export enum NavigationRoute {
  Home= 'tabs'
}
